import { MultiSelectionBox } from "../CanvasGui/MultiSelectionBox";
import { PointOps } from "../Graphics/PointOps";
import { InputListener, InputRegisterer } from "../Input/InputHandler";
import { NumPair4, Point } from "../Misc/Utils";
import { AssistiveObjectsHolder } from "./AssistiveObjects/AssistiveObjectsHandler";
import { BObject } from "./BObject";
import { BObjectProvider } from "./Providers/BObjectProvider";

//Class that holds selected objects for modification purposes
//Used by BScene
export class ObjSelectionHolder implements InputListener{
    private selectedObjs : Array<BObject> = Array()
    public isMultiSelectOn: boolean = false
    
    private inputRegisterer: InputRegisterer
    private assistiveObjsHolder: AssistiveObjectsHolder
    private sceneObjects: BObjectProvider
    
    //Used to draw the dragging box when user wants to select multiple objects at once
    private multiSelectionBox = new MultiSelectionBox();
    private isDragSelection = false; //tracks if user is dragging or not
    
    constructor(inputHandler: InputRegisterer, assistiveObjsHolder: AssistiveObjectsHolder, objsProvider: BObjectProvider){
        this.inputRegisterer = inputHandler;
        this.assistiveObjsHolder = assistiveObjsHolder;
        this.sceneObjects = objsProvider
        this.inputRegisterer.addListener(this);
        console.log("obj selection holder registered")
    }

    onMouseDown(point: Point): void {
        if(this.isEmpty()){ //Start dragging only if there are no selected objects
            this.startMultiSelectionOnDrag(point);
        }
    }
    onMouseUp(point: Point): void {
        if(this.isDragSelection){ //when user stops dragging, we dont need to show the translucent box
            this.stopMultiSelectionOnDrag();
        }
    }
    onMouseMove(from: Point, to: Point): void {
        if(this.isDragSelection){
            this.onMultiSelectionOnDrag(to);
        }
    }
    onDoubleClick(point: Point): void {
        //do nothing
    }

    private startMultiSelectionOnDrag(from: Point){
        this.multiSelectionBox.updateStartPos(from);
        this.multiSelectionBox.updateEndPos(from);
        this.assistiveObjsHolder.addAssistiveObject(this.multiSelectionBox);
        this.isDragSelection = true;
        this.setMultiSelectOn(true);
    }

    private onMultiSelectionOnDrag(to: Point){
        this.multiSelectionBox.updateEndPos(to);
        this.selectObjectsIfInBounds(this.multiSelectionBox.getBox());
    }

    private stopMultiSelectionOnDrag(){
        this.isDragSelection = false;
        this.assistiveObjsHolder.removeAssistiveObject(this.multiSelectionBox);
        this.setMultiSelectOn(false);
    }

    private selectObjectsIfInBounds(boxBounds: NumPair4){//box bounds  = [x, y, w, h]
        for(let obj of this.sceneObjects.getObjects()){
            if(PointOps.containedInRect(obj.getCentre(), [boxBounds[0], boxBounds[1]], [boxBounds[2], boxBounds[3]])){
                this.addToSelection(obj);
            }
        }
    }

    //Adds to the selection. If multi select is on, 
    //appends else stores the given obj as the only selection obj
    public addToSelection(newObj : BObject){
        if(!this.isMultiSelectOn){
            console.log("clearing selection");
            this.clearSelection();
        }
        this.selectedObjs.push(newObj);
    }

    //Sets the whether multi select is on or not
    public setMultiSelectOn(isSet: boolean){
        this.isMultiSelectOn = isSet;
    }

    //Checks if the point is withing the selection bounds
    public checkIfAlreadyInSelection(point: Point): Boolean{
        var isInBounds = false;
        for(var obj of this.selectedObjs){
            isInBounds = isInBounds || obj.checkSelection(point);
        }
        return isInBounds;
    }

    public edit(lastMousePoint : Point, curMousePoint : Point){
        if(this.isDragSelection) return; //while dragging, we dont want to edit objects
        
        for(let obj of this.selectedObjs){
            obj.edit(lastMousePoint, curMousePoint);
        }
    }

    //Method that allows editing of objs
    public editStructure(start: boolean){
        for(let obj of this.selectedObjs){
            if(obj.isEditableStructure()){
                console.log("input:"+this.inputRegisterer);
                obj.editStructure(start, this.inputRegisterer);
            }
        }
    }

    //Allows control points of objs to be drawn
    public drawControlPoints(outlineCanvasCtx : CanvasRenderingContext2D, curFrame: number){
        for(let obj of this.selectedObjs){
            obj.drawControlPoints(outlineCanvasCtx, curFrame);
        }
    }

    //Returns all selected objects
    public getAllObjects(): Array<BObject>{
        return this.selectedObjs;
    }

    //Emptys the selection list
    public clearSelection(){
        this.selectedObjs.length = 0;
    }

    //Retuns the last obj that was added to the list. If empty returns null
    public getLastAddedObj(): BObject|null{
        if(this.selectedObjs.length > 0){
            return this.selectedObjs[this.selectedObjs.length-1];
        }else{
            return null;
        }
    }

    //Removes last obj in selected list and returns it. null if there is nothing to remove
    public removeLastAddedObj(): BObject|null{
        if(this.selectedObjs.length > 0){
            var last = this.selectedObjs.pop();
            if(last!=undefined) return last;
        }
        return null;
    }

    //Method to check if the selected list has a particular object
    public hasObjectWithId(id: number): Boolean{
        for(var obj of this.selectedObjs){
            if(obj.getId() == id){
                return true;
            }
        }
        return false;
    }

    //Method to remove a particular object from the selected list
    public removeObjectWithId(id: number): Boolean{
        var count = this.selectedObjs.length;
        for(var i=0; i<count; i++){
            if(this.selectedObjs[i].getId() == id){
                this.selectedObjs.splice(i, 1);
                return true;
            }
        }
        return false;
    }

    public getCountOfSelectedObjects(): number{
        return this.selectedObjs.length;
    }

    //Returns whether selection objs are empty or not
    public isEmpty(): boolean{
        return this.selectedObjs.length == 0;
    }

    public holdsMultipleSelectedObjs(): boolean{
        return this.selectedObjs.length > 1;
    }

    //Clones all objects in selected list and returns the list of cloned objects
    public cloneSelected(): Array<BObject>{
        var clones = Array<BObject>();
        for(var obj of this.selectedObjs){
            clones.push(obj.clone());
        }
        return clones;
    }
}